import React, {FC} from "react";
import {
  Container,
  NavWrapper,
  TitleBig
} from './styles'
import {
  Overview,
  BillingHistory,
  Invoices,
  Services,
  PaymentMethods,
} from './components'
import { Tabs } from "../../components";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { tabPermissionSurfaces, usePermissionDecision } from '../../permissions';


const BillingPage:FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const canViewOverview = usePermissionDecision(tabPermissionSurfaces.billingOverview).allowed
  const canViewServices = usePermissionDecision(tabPermissionSurfaces.billingServices).allowed
  const canViewInvoices = usePermissionDecision(tabPermissionSurfaces.billingInvoices).allowed
  const canViewHistory = usePermissionDecision(tabPermissionSurfaces.billingHistory).allowed
  const canViewPaymentMethods = usePermissionDecision(tabPermissionSurfaces.billingPaymentMethods).allowed
  const tabs = [
    {
      title:t("OVERVIEW"),
      slug:'overview',
      id:'1',
      visible: canViewOverview,
    },
    {
      title:t("SERVICES"),
      slug:'services',
      id:'2',
      visible: canViewServices,
    },
    {
      title:t("INVOICES"),
      slug:'invoices',
      id:'3',
      visible: canViewInvoices,
    },
    {
      title:t("BILLING_HISTORY"),
      slug:'billing_history',
      id:'4',
      visible: canViewHistory,
    },
    {
      title:t("PAYMENT_METHODS"),
      slug:'payment-methods',
      id:'5',
      visible: canViewPaymentMethods,
    },
  ]
  const visibleTabs = tabs.filter((tab) => tab.visible)
  const defaultTab = visibleTabs[0]?.slug
  if (!defaultTab) {
    return <Navigate replace to="/403" />
  }
  if (location.pathname === '/billing' || location.pathname === '/billing/') {
    return <Navigate replace to={`/billing/${defaultTab}`} />
  }
  return(
    <Container>
      <TitleBig>{t("BILLING")}</TitleBig>
      <NavWrapper>
        <div>
          <Tabs
            tabs={visibleTabs}
            size='display'
            blockNavigate
            onChange={(tab) => navigate(`/billing/${tab}`)}
          />
        </div>
      </NavWrapper>
      <Routes>
        <Route index element={<Navigate replace to={defaultTab} />} />
        {canViewOverview && <Route path='/overview' element={<Overview />}/>}
        {canViewServices && <Route path='/services' element={<Services />}/>}
        {canViewInvoices && <Route path='/invoices' element={<Invoices />}/>}
        {canViewHistory && <Route path='/billing_history' element={<BillingHistory />}/>}
        {canViewPaymentMethods && <Route path='/payment-methods' element={<PaymentMethods />}/>}
        <Route path='*' element={<Navigate replace to={defaultTab} />} />
      </Routes>
    </Container>
  )
}

export default BillingPage
